import React, { useState, useEffect, useRef } from 'react';
import { Row, Col, Button, ListGroup, ListGroupItem } from 'reactstrap';
import { Label } from 'reactstrap';
import { faEdit } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

//Components
import MainCard from '../../../components/MainCard/MainCard';
import Loading from '../../../components/Loading/Loading';
import TextField from '../../../components/TextField/TextField';
import RichTextEditor from 'components/RichTextEditor';

//Api
import certificado_api from '../../../api/certificado_api';

//Helpers
import { showMessage } from '../../../helpers/message';
import { validarCampos, objCampo, PrintValidate } from '../../../helpers/ValidadorDeCampos';

//Estado inicial para um certificado
function initialStateCertificado(tipoDocumento = "") {
    return {
        tbPrefeituras_id: 32,
        identificacao: "",
        tipoDocumento: tipoDocumento,
        conteudo: "",
        situacao: "Ativo",
    }
}
export default function NovoCertificado({ tipoDocumento, id, loading, setLoading, btnVoltar }) {

    //Referencia para o editor do joditEditor
    const editor = useRef(null);

    //Estado para guardar os dados do certificado
    const [certificado, setCertificado] = useState(initialStateCertificado(tipoDocumento));

    //Estado para controle de errors dos campos obrigatorios
    const [errors, setErrors] = useState({});

    //Campos obrigatorios do certificado
    const campos = [
        objCampo({ name: "identificacao", required: true }),
        objCampo({ name: "conteudo", required: true }),
        objCampo({ name: "situacao", required: true }),
    ]

    //Opções do select de situação
    const optionsSituacao = [
        { value: "Ativo", text: "Ativo" },
        { value: "Inativo", text: "Inativo" },
    ]

    //Carrega os campos do certificado ao inicializar o componente
    useEffect(() => {
        if (id) {
            setLoading(true);
            certificado_api.GetItem(id).then(response => {
                setCertificado(response.data);
                setLoading(false);
            }).catch(e => {
                showMessage("Aviso", e.message, "error", null)
                setLoading(false);
            })
        }
    }, []);

    //Change para os campos do certificado
    const onChange = (e) => {
        const { name, value } = e.target;
        const _certificado = { ...certificado, [name]: value };
        const campo = campos.filter(c => c.name === name);
        const erros = validarCampos(_certificado, campo);
        if (erros[1].length == 0) {
            const _errors = { ...errors };
            delete _errors[name];
            setErrors(_errors);
        } else {
            setErrors({ ...errors, ...erros[0] });
        }
        setCertificado(_certificado);
    }

    //Cadastra/edita um certificado
    const onClickBtnSaveAndEdit = () => {
        const erros = validarCampos(certificado, campos);
        if (erros[1].length > 0) {
            setErrors(erros[0]);
            return;
        }
        setLoading(true);
        if (!id) {

            certificado_api.Post(certificado).then(response => {
                setCertificado(initialStateCertificado);
                showMessage("Sucesso", "Certificado cadastrado com sucesso", "success", btnVoltar);
                setLoading(false);
            }).catch(e => {
                showMessage("Aviso", e.message, "error");
                setLoading(false);
            });
        } else {
            certificado_api.Put(certificado).then(response => {
                showMessage("Sucesso", "Certificado Editado com sucesso", "success", btnVoltar);
                setLoading(false);
            }).catch(e => {
                showMessage("Aviso", e.message, "error");
                setLoading(false);
            });
        }
    }
    return (
        <>
            {loading && <Loading />}
            <MainCard btnVoltarInTop={btnVoltar} title={id ? "Editar Certificado" : "Novo Certificado"}>
                <ListGroup>
                    <ListGroupItem className='text-light bg-dark fw-bold'>Palavras Chaves</ListGroupItem>
                    <ListGroupItem><span className="fw-bold">%Assinatura%</span> - Assinatura do responsável pelo Documento</ListGroupItem>
                    <ListGroupItem><span className="fw-bold">%DataEmissao%</span> - Data de emissão do documento. Ex.: 01 de Janeiro de 2018</ListGroupItem>
                    <ListGroupItem><span className="fw-bold">%NomePrefeitura%</span> - Nome da Prefeitura</ListGroupItem>
                    <ListGroupItem><span className="fw-bold">%EnderecoPrefeitura%</span> - Endereço da Prefeitura</ListGroupItem>
                    <ListGroupItem><span className="fw-bold">%NomeTransportador%</span> - Nome fantasia do Transportador</ListGroupItem>
                    <ListGroupItem><span className="fw-bold">%RazaoTransportador%</span> - Razão do Transportador</ListGroupItem>
                    <ListGroupItem><span className="fw-bold">%CNPJTransportador%</span> - Nome da Prefeitura</ListGroupItem>
                    <ListGroupItem><span className="fw-bold">%TiposColetaTransportador%</span> - Exibe os tipo de coleta que o Transportador atua</ListGroupItem>
                    <ListGroupItem><span className="fw-bold">%ValidadeTransportador%</span> - Data de validade de contrato do Transportador</ListGroupItem>
                    <ListGroupItem><span className="fw-bold">%CodigoCadastroTransportador%</span> - Código de Cadastro do Transportador</ListGroupItem>
                    <ListGroupItem><span className="fw-bold">%CredenciamentoTransportador%</span> - Número de Credenciamento do Transportador</ListGroupItem>
                    <ListGroupItem><span className="fw-bold">%TipoVeiculo%</span> Tipo do Veículo</ListGroupItem>
                    <ListGroupItem><span className="fw-bold">%MarcaVeiculo%</span> - Marca do Veiculo</ListGroupItem>
                    <ListGroupItem><span className="fw-bold">%AnoVeiculo%</span> - Ano do Veículo</ListGroupItem>
                    <ListGroupItem><span className="fw-bold">%PlacaVeiculo%</span> - Placa do Veículo</ListGroupItem>
                    <ListGroupItem><span className="fw-bold">%FinalidadeVeiculo%</span> - Finalidade do Veículo</ListGroupItem>
                    <ListGroupItem><span className="fw-bold">%DescricaoEquipamento%</span> - Descrição do Equipamento comportado pelo Veículo</ListGroupItem>
                    <ListGroupItem><span className="fw-bold">%CapacidadeVeiculo%</span> - Capacidade do Veículo</ListGroupItem>
                    <ListGroupItem><span className="fw-bold">%NumeroSerieVeiculo%</span> - Número Série do Veículo</ListGroupItem>
                    <ListGroupItem><span className="fw-bold">%VistoriaVeiculo%</span> - Data de Vistoria do Veículo</ListGroupItem>
                    <ListGroupItem><span className="fw-bold">%ValidadeVistoriaVeiculo%</span> - Data de Validade da Vistoria do Veículo</ListGroupItem>
                    <ListGroupItem><span className="fw-bold">tabela_veiculos </span> - Inserir como id para tabelas referente a veículos</ListGroupItem>
                    <ListGroupItem><span className="fw-bold">%NumeroDoProcesso%</span> - Numero Do Processo</ListGroupItem>
                </ListGroup>
                <Row className='mb-4'>
                    <Col md="12" lg="12"><span className="text-danger fw-bold">*</span> Campos obrigatórios</Col>
                </Row>
                <Row>
                    <Col md="12" lg="6">
                        <TextField invalid={errors.identificacao ? true : false} maxLength={"200"} label={"* Identificação do documento"} name="identificacao" onChange={onChange} value={certificado.identificacao} />
                        <PrintValidate field={"identificacao"} errors={errors} />
                    </Col>
                    <Col md="12" lg="6">
                        <TextField invalid={errors.situacao ? true : false} label={"* Situação"} name="situacao" type="select" options={optionsSituacao} onChange={onChange} value={certificado.situacao} />
                        <PrintValidate field={"situacao"} errors={errors} />
                    </Col>
                </Row>
                <Row style={{ height: "75vh" }}>
                    <Col md="12" lg="12" className={`joditCol ${errors.conteudo ? "disable" : ""}`}>
                        <Label className=' label'>
                            * Conteudo
                        </Label>
                        {!loading && <RichTextEditor name="conteudo" value={certificado.conteudo} onChange={onChange} invalid={errors.conteudo ? true : false} />}
                    </Col>
                </Row>
                <div className='d-flex align-items-center justify-content-center mt-4'>
                    <Button color={certificado.id ? "warning text-light" : 'success'} className='bg-gradient' onClick={onClickBtnSaveAndEdit}>{id ? <><FontAwesomeIcon icon={faEdit} /> Editar</> : <>+ Adicionar</>}</Button>
                </div>
            </MainCard>
        </>
    )
}